// redux/attorneySlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  firstName: "",
  lastName: "",
  firmName: "",
  practiceAreas: [], // Array for selected Areas of Law
  firmSize: "",
  email: "",
  phone: "", // Phone Number
  zipCode: "",
  referral: "",
  communicationPreference: true,
};

const attorneySlice = createSlice({
  name: "attorney",
  initialState,
  reducers: {
    updateLegalInfo: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetLegalInfo: () => initialState, // Action to reset the state
  },
});

export const { updateLegalInfo, resetLegalInfo } = attorneySlice.actions;
export default attorneySlice.reducer;
